import produce from 'immer';

// TYPES
import { Types, AtualizarUnidade } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: AtualizarUnidade = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarUnidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_UNIDADE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_UNIDADE_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.ATUALIZAR_UNIDADE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_UNIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
